module.exports = __webpack_public_path__ + "static/img/15.eb212ef.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/15.jpeg
// module id = 6vl2
// module chunks = 3